export default __webpack_public_path__ + "static/media/img10.eff83d77.png";